import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'


//근골격계 증상 조사목록 레포트
export function getMuscleSymptomReport(param) {
  let responseType = "blob"
  return request({
    url: `/api/getMuscleSymptomReport`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data:param,
    responseType: responseType
  })
}

//질문 답변
export function getQuestionList(param, isNotify) {
  return request({
    url: '/api/getQuestionList',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
//질문 답변
export function getQuestionList2(param, isNotify) {
  return request({
    url: '/api/getQuestionList2',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
//근골격계 유해요인 조사목록 조회
export function getMuscleSymptonHrInfo(param, isNotify) {
  return request({
    url: '/api/getMuscleSymptonHrInfo',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
//근골격계 유해요인 조사목록 조회
export function getMuscleSymptonHrSearchInfo(param, isNotify) {
  return request({
    url: '/api/getMuscleSymptonHrSearchInfo',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
//근골격계 유해요인 조사목록 조회
export function getMuscleSymptonSearch(param, isNotify) {
  return request({
    url: '/api/getMuscleSymptonSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
//근골격계 유해요인 디테일 조회
export function getMuscleSymptonDetailSearch(param, isNotify) {
  return request({
    url: '/api/getMuscleSymptonDetailSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
//근골격계 유해요인 디테일 조회
export function getMyMuscleSymptonDetailSearch(param, isNotify) {
  return request({
    url: '/api/getMyMuscleSymptonDetailSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
//근골격계 유해요인 팝업 조회
export function getMuscleSymptonPopupSearch(param, isNotify) {
  return request({
    url: '/api/getMuscleSymptonPopupSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
//근골격계 조사계획 팝업 조회
export function getMuscleSymptonForHazardPopupSearch(param, isNotify) {
  return request({
    url: '/api/getMuscleSymptonForHazardPopupSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
//나의 근골격계 조사 인원 조회
export function getMyMuscleSymptonUserInfo(param, isNotify) {
  return request({
    url: '/api/getMyMuscleSymptonUserInfo',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
//나의 근골격계 조사 인원 조회
export function getMyMuscleSymptonPopupSearch(param, isNotify) {
  return request({
    url: '/api/getMyMuscleSymptonPopupSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

//근골격계 유해요인 조사목록 저장
export function saveMuscleSymptonSearch(param, isNotify) {
  return request({
    url: '/api/saveMuscleSymptonSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}
export function saveMuscleSymptonDetailSearch(param, isNotify) {
  return request({
    url: '/api/saveMuscleSymptonDetailSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}
export function saveMuscleSymptonPopupSearch(param, isNotify) {
  return request({
    url: '/api/saveMuscleSymptonPopupSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

export function sendMyMuscleSymptonPopupSearch(param, isNotify) {
  return request({
    url: '/api/sendMyMuscleSymptonPopupSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

//근골격계 유해요인 조사목록 삭제
export function deleteMuscleSymptonSearch(param, isNotify) {
  return request({
    url: '/api/deleteMuscleSymptonSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved,deleted
  })
}
//근골격계 유해요인 조사목록 삭제
export function deleteMuscleSymptonDetailSearch(param, isNotify) {
  return request({
    url: '/api/deleteMuscleSymptonDetailSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved,deleted
  })
}